import { useEffect, useState, React } from 'react';
import { Link } from "react-router-dom";
import HeaderEN from "../headerEN/headeren";
import FooterEN from "../footerEN/footer";
import './privacypolicy.scss';

const HomePage = () => {

  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
  
  },[])
  
  return (
    <div class="main-fluid">
      <HeaderEN />
      {/* DESK TOP AND TABS SECTION STARTS HERE */}
      
      <div class="d-md-block">
        <div class="privacy-policy-bannermain-en">
          <div class="privacy-policy-banner-con-en">
            <div class="privacy-policy-banner-sec-en">
              <h1 class="privacy-policy-heading-en">Privacy Policy</h1>
            </div>
          </div>
        </div>
        <div class="privacy-policy-banner-con-en">
          <div class="pri-pol-conent-en pt-4">
            <h2>
              Privacy Policy
            </h2>
            <h3>
              Last updated date: 02-MAR-2026
            </h3>
            <p>Khimji Ramdas Insurance Services (“we,” “us,” or “our”) is committed to safeguarding user privacy and ensuring the confidentiality of the information collected while using our services and website in accordance with the Oman Personal Data Protection Law (PDPL) - Royal Decree No. 6/2022 and it’s Executive Regulations (MD 34/2024). This privacy notice outlines how we collect use, share and protect your personal data, your rights under PDPL and how to exercise those rights. </p>
            <h2>Contact Information:</h2>
            <b>Data Controller Information</b><br></br>
            <b>Khimji Ramdas Insurance Services</b><br></br>
            <p>PO Box 3295, 112, Muscat, Sultanate of Oman</p><br></br>
            <b>Contact Information of Data Protection Officer</b><br></br>
            <p><b>Name:</b> Mr. Ali Said Ali Al Kalbani</p>
            <p><b>Email: </b><a href="mailto:privacy@kr.om">privacy@kr.om</a></p>
            <p><b>Contact: </b>+968 98515813</p>

            <p>The DPO is responsible for ensuring Khimji Ramdas Insurance Services compliance with the PDPL and for addressing all inquiries related to the processing of personal data.</p>
            <h2>Our Role</h2>

            <p>Under the Oman PDPL (Royal Decree No. 6/2022), Khimji Ramdas Insurance Services operate in two capacities:
              <ul>
                <li>
                  Data Controller: We act as the Controller when we determine the purpose and means of processing your data to provide our services to you.
                </li>
                <li> 
                  Data Processor: We act as a Processor when we handle personal data solely on behalf of, and according to the documented instructions of, a Data Controller (such as a corporate employer or partner). When we play a role of a processor we request you to check your controller’s Privacy practices before sharing with us.
                </li>
              </ul>
            </p>
            <h2>Personal Data we collect</h2>

            <p>Khimji Ramdas Insurance Services collects only the minimum necessary data required to provide our services and comply with PDPL. We collect information that identifies you or makes you identifiable. The type of data we collect depends on your interaction with us (e.g., whether you are a retail customer, a corporate partner, or a website visitor).</p>

            <h3>1. Information You Provide Directly </h3>

            <p>This is data you give us when you register for an account, purchase a product, or contact our support team.
              <ul>
                <li>
                  Identity Data: Full name, Civil ID number (Oman ID) or Passport number, and date of birth. 
                </li>
                <li> 
                	Contact Data: Personal or work email address, mobile number, and physical billing/delivery address. 
                </li>
                <li>Financial Data: Bank account details or payment card info (collected securely for transactions). </li>
              </ul>
            </p>

            <h3>2. Information Collected Automatically </h3>

            <p>When you visit our digital platforms, we use cookies and similar technologies to collect technical data.
            <ul>
              <li>
                Technical Data: Your IP address, login data, browser type and version, time zone setting, and operating system. 
              </li>
              <li>
                Usage Data: Information about how you use our website, products, and services (e.g., pages viewed or links clicked). 
              </li>
            </ul>
            </p>

            <h2>
              Minor Data
            </h2>
            <p>
              Our website is not intended for use by minors. However, in some scenarios, we only collect personal data of minors (under 18 years of age) from a parent or legal guardian for the purpose of Insurance Purposes and related processing. This information is used strictly for its intended purpose and is never used for marketing.</p>
              <p>
                Parent or legal guardian you may exercise any of your rights under the Oman PDPL by contacting us at: <a href="mailto:privacy@kr.om">privacy@kr.om</a>
            </p>

            <h2>
              Legal Basis & Purpose of Processing
            </h2>
            <p>
              We process your personal data only when a valid legal basis exists under the Oman PDPL:
              <ul>
                <li>
                  Explicit Consent: We process your personal data if you have given your clear, written, or electronic approval/consent for the same. Where we rely on your consent to use your personal data, you have the right to withdraw the consent at any time. Please contact us using the details in the Contact us section.
                </li>
                <li>
                  Contractual Necessity: We process your data to fulfil the contractual necessity and provide you the travel services you have requested.  
                </li>
                <li>
                  Legal Obligations: We process your personal data necessary for compliance with the any legal obligation, court judgments, or regulatory requirements.
                </li>
                <li>
                  Security of the Organization: To protect our systems, prevent fraud, and ensure the safety of our operations.
                </li>
              </ul>
            </p>
            <h2>
              Our Purpose of processing
            </h2>
            <p>
              <ul>
                <li>
                  As a Data Controller: <br></br>
                  We process your personal data strictly for the services purposes for which you engage us. Your data is treated as highly confidential and managed in full accordance with the Oman PDPL.
                </li>
                <li>
                  As a Data Processor:<br></br>
                  When we act on behalf of another Controller (such as your employer), we process personal data strictly according to their documented written instructions and the safety standards mandated by the Law.
                </li>
              </ul>
            </p>
            <h2>
              Our Commitment on Data Protection to Global Clients:
            </h2>
            <p>
              We treat all personal data with the highest level of care and security. Khimji Ramdas Insurance Services operates in full alignment with applicable privacy regulations, including the Oman Personal Data Protection Law (Royal Decree 6/2022). We ensure that our processing activities respect the privacy standards of our global clients and the rights of their data subjects.
            </p>
            <h2>
              Data Subject Rights Under PDPL
            </h2>
            <p>
              As a data subject, you have the following rights:
              <ul>
                <li>
                 Access: You have right to request a copy of your personal data held by Khimji Ramdas Insurance Services
                </li>
                <li>
                  Correction: You have a right to request correction of inaccurate or outdated data.
                </li>
                <li>
                  Erasure: You have a right to request deletion of your data under specific circumstances.
                </li>
                <li>
                  Deletion: You have right to request erasure of your personal data, for example if consent is withdrawn or the data is no longer necessary.
                </li>
                <li>
                  Withdrawal of Consent: You have a right to revoke previously given consent at any time.
                </li>
                <li>
                  Restriction: You have right to request temporary halt of processing under specific conditions.
                </li>
                <li>
                  Data Portability: You have right to request transfer of your data in a machine-readable format
                </li>
                <li>
                  Objection: You have right to object to processing for direct marketing or other reasons.
                </li>
                <li>
                  Complaint: If you have any questions or concerns regarding our privacy practices, we encourage you to contact our Data Protection Officer (DPO) directly. If our DPO is unable to resolve your concern to your satisfaction, you maintain the right to escalate your complaint to the Ministry of Transport, Communications and Information Technology (MTCIT). 
                </li>
              </ul>
              To exercise any of these rights, please contact: <a href="mailto:privacy@kr.om">privacy@kr.om</a>
            </p>
            <h2>
              Cookies and Google Analytics:
            </h2>
            <p>
              We use strictly necessary cookies to ensure the proper functioning and security of our website and to analyze website traffic using Google Analytics. Analytics cookies will only be set with your consent. You can accept or reject these cookies.  services to monitor the site performance. We do not process any personal data using the Google analytics services.
            </p>
            <h2>
              Marketing & Promotional Activities
            </h2>
            <p>
              We only use your personal information for direct marketing if you provide explicit consent. All our marketing communications include clear instructions on how to opt out at any time. You can withdraw your consent or change your preferences by replying directly to our emails, messaging us on social media, or contacting us through this website.
            </p>
            <h2>
              You information shared with other:
            </h2>
            <h3>
              Recipient of your data:
            </h3>
            <p>
              Third party service providers: We may share personal data we collect about you with our third-party service providers. The categories of service providers to whom we entrust personal data including IT and related services such as cloud-based centers, analytics service provides, Travel partners.  
            </p>

            <p>
              Marketing Partners: We may share your information with partners helps us with marketing activities after better understanding your preferences and with your consent.
            </p>

            <p>
              Disclosures to protect us or others: We may access, preserve and disclose any information we store associated with you to external parties if we in good faith believe doing so is required or appropriate to comply with law enforcement or national security request and legal process. 
            </p>

            <p>
              Disclosures in the event of merger, sale or other asset transfer: If we are involved in a merge, acquisition, or sale of assets or transition of service to another provider then your information may be sold or transferred as part of such a transaction, as permitted by law and /or contract.
            </p>
            <h2>
              Third Party Service Provider:
            </h2>
            <p>
              To deliver targeted travel services and updates, we use multiple third-party service providers. 
            </p>
            <p>
              We have established formal Data Protection Agreements with third party service providers to ensure your personal data is handled with a level of protection that meets the standards of the Oman PDPL.
            </p>
            <h2>
              Limitation of Liability for Publicly Shared Data:
            </h2>
            <p>
              While Khimji Ramdas Insurance Services handles all private correspondence (Direct Messages) in accordance with the Oman PDPL (Royal Decree No. 6/2022), we do not encourage the disclosure of non-public personal information in public forums or comment sections. Users are advised that information shared publicly is outside of our exclusive control. Consequently, Khimji Ramdas Insurance Services shall not be held liable for any damages, losses, or privacy breaches arising from the misuse of such information by other users or third parties. 
            </p>
            <h2>
              Retention of Personal Data:
            </h2>
            <p>
              We retain your personal data only as long as necessary to fulfil the purpose for which it was collected or as required by law. For regulatory, auditing, we store data for a minimum 10 years following the end of our relationship unless otherwise required by law or applicable contracts. There can be scenarios wherein to fulfil the legal obligations we might have to retain the data for longer.  Within this period, you may exercise any of your rights as per Oman PDPL. For more information, please refer to the "Rights of the Data Subject" section.
            </p>
            <h2>
              Data Security:
            </h2>
            <p>
              We implement appropriate technical and organizational measures to protect the personal information we collect from or about you (including personal identifiable information) against unauthorized access, use, alteration, or disclosure. These measures include, among others:
              <ul>
                <li>
                  Encryption of personal data at rest and in transit, where applicable
                </li>
                <li>
                  Role-based access controls and audit logging
                </li>
                <li>
                  Staff training and internal privacy and information security governance measures
                </li>
              </ul>
            </p>
            <h2>
              Cross-Border Data Transfers:
            </h2>
             <p>
              To facilitate underwriting, reinsurance, policy administration, claims handling etc., the relevant data may be shared with insurers, reinsurers, authorized service providers and secure cloud systems located within or outside the Sultanate of Oman, in compliance with applicable data protection laws and consent requirements
              </p>
              <p> To ensure the safety of your information, we conduct Transfer Impact Assessments and maintain Data Protection Agreements with our partners to guarantee a level of protection equivalent to the Oman PDPL.
            </p>
            <h2>
              Link to other Sites:
            </h2>
            <p>
              Our Services may contain links to other websites and services. Any information that you provide on or to a third-party website or service is provided directly to the owner of the website or service and is subject to that party’s privacy notice. Our privacy notice does not apply to such websites or services and we’re not responsible for the content, privacy, or security practices and policies of those websites or services. To protect your information, we recommend that you carefully review the privacy policies of other websites and services that you access.
            </p>
            <h2>
              Breach Notification:
            </h2>
            <p>
               A Personal Data Breach may include any unauthorized or unlawful access, disclosure, alterations, loss, destruction misuse or compromise of Personal Data processed by us
            </p>
            <p>
              In case of a personal data breach we shall take appropriate technical and organizational measures to contain, investigate, assess and remediate the incident in accordance with the Oman Personal Data Protection Law (Royal Decree 6/2022) and its implementing regulations (PDPL) we ensure that we take the relevant steps to ensure that the breach is mitigate and we comply. 
            </p>
            <p>
              We maintain an internal data breach response procedure to ensure prompt identification, documentation, escalation and mitigation of any incident.
            </p>
            <h2>
              Changes to Privacy Notice:
            </h2>
            <p>
              Any information that we collect is subject to the privacy notice in effect at the time that the information is collected. We may, however, modify and revise this privacy notice from time to time. We encourage you to review this privacy notice periodically to stay informed about how we process and protect your personal data.
            </p>
            <p>
              The last updated date at the top of this privacy notice indicates when it was most recently revised.
            </p>
            <h2>
              Complaints and Contact Information:
            </h2>
            <p>
              If you believe your personal data has been mishandled or your privacy rights are violated:
            </p>
            <p>
              Please contact us at <a href="mailto:privacy@kr.om">privacy@kr.om</a>
            </p>

          </div>
        </div>
      </div>
      {/* DESK TOP AND TABS SECTION ENDS HERE */}

      {/* MOBILE PAGE STARTS HERE */}
      <div class="privacy-policy-bannermain-en hidden-desktop hidden-md-device hidden-lg">
        <div class="pri-pol-conent-en">
          <h1 class="privacy-title-en">Privacy Policy</h1>
          <p>KR Insurance services welcome you to its website and looks forward to a meaningful interaction with you.</p>
          <p>KR Insurance services are committed to keeping your information private. By 'your information' we mean any information about you that you or third parties provide to us. This policy relates to the privacy of your information at www.krinsurance.com</p>

          <p>KR Insurance services respect your right to privacy. Any personal information that you share with us shall be entitled to privacy and kept confidential.</p>

          <p>KR Insurance services assures you that your personal information shall not be used/disclosed by it, save for the purpose of doing the intended business with you, or if required to be disclosed under the due process of law.</p>

          <p>KR Insurance services assures you that in the event of your personal information being shared with its subsidiaries, business associates etc., such sharing of information shall be for the purpose of doing the intended business with you.</p>

          <p>KR Insurance services reserves its rights to collect, analyze and disseminate aggregate site usage patterns of all its visitors with a view to enhancing services to its visitors. This includes sharing the information with its subsidiaries, and business associates as a general business practice.</p>

          <p>In the course of its business KR Insurance services may hold on-line contests and surveys as permitted by law and it reserves its right to use and disseminate the information so collected to enhance its services to the visitors. This shall also include sharing the information with its subsidiaries and business associates as a general business practice.</p>

          <p>While KR Insurance services assures you that it will do its best to ensure the privacy and security of your personal information, it shall not be responsible in any manner whatsoever for any violation or misuse of your personal information by unauthorized persons consequent to misuse of the internet environment.</p>

          <p>KR Insurance services reserves its rights to revise this privacy policy from time to time at its discretion with a view to making the policy more user friendly.</p>

          <p>In the design of our website, we have taken care to draw your attention to this privacy policy so that you are aware of the terms under which you may decide to share your personal information with us. Accordingly, should you choose to share your personal information with us, KR Insurance services will assume that you have no objections to the terms of this privacy</p>
        </div>
      </div>
      {/* MOBILE PAGE ENDS HERE */}

      {/* FOOTER SECTION STARTS HERE */}
      <FooterEN />
      {/* FOOTER SECTION ENDS HERE */}
    </div>
  );
}

export default HomePage;